module.exports = __webpack_public_path__ + "img/kitkitphoto12.6ecec9a4.jpg";